module.exports = __webpack_public_path__ + "static/002-85aa2208677d2de5fed567a9cec6e8f0.png";